import { render, staticRenderFns } from "./insertOil.vue?vue&type=template&id=6297aa5c&scoped=true&"
import script from "./insertOil.vue?vue&type=script&lang=js&"
export * from "./insertOil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297aa5c",
  null
  
)

export default component.exports